import React from 'react';
import { Row,Col ,Avatar,Popover } from 'antd';
import { Breadcrumb, Icon } from 'antd';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux'
import './index.less';
import Axios from '@/axios';
import Util from '@/utils/utils';
import { message } from 'antd';

class Header extends React.Component{
    state = {}
    componentWillMount(){

    }
    handleLogout = ()=>{
        // window.open(`/#/login`,'_self');
        // window.location.reload();
        window.open(`/#/login`, '_self');
        // Axios.loginOut({
        //     block: '/user',
        //     url: '/logout',
        //     params: {},
        // }).then((res) => {
        //     if (res.code == 0) {
        //         message.success('退出成功', 1).then(() => {
        //             localStorage.setItem("token","");
        //             window.open(`/#/login`, '_self');
        //             setTimeout(() => {
        //                 window.location.reload();
        //             }, 1)
        //         });
        //     }
        // }).catch((error) => {
        //     //console.log(error);
        // })
    }
    render (){
        const account = localStorage.getItem('account');
        return(
            <div>
                <div className="header">
                    <Row className="top">
                        <Col span="8" className="left">
                            <span className="welcome-txt">欢迎使用英超名人堂管理系统！</span>
                        </Col>
                        <Col span="16" className='right'>
                            <div className="basic-info">
                                {/* <span className="user-name">{account ? account : ''}</span> */}
                                <Icon type="poweroff" style={{ color: "#333" }} onClick={this.handleLogout} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        menuName: state.menuName
    }
};
export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js